export const addPetWindow = {
    addPetWindowAddPet: {
        rbmail: {
            type: 'click',
            id: '72010824',
        },
    },
    addPetWindowChangePet: {
        rbmail: {
            type: 'click',
            id: '72011586',
        },
    },
    addPetWindowDeletePet: {
        rbmail: {
            type: 'click',
            id: '72011589',
        },
    },
    addPetWindowFirstStep: {
        rbmail: {
            type: 'click',
            id: '72010826',
        },
    },
    addPetWindowSecondStep: {
        rbmail: {
            type: 'click',
            id: '72010833',
        },
    },
    addPetWindowThirdStep: {
        rbmail: {
            type: 'click',
            id: '72010834',
        },
    },
    addPetWindowFourthStep: {
        rbmail: {
            type: 'click',
            id: '72010837',
        },
    },
    addPetFormBlock1: {
        rbmail: {
            type: 'click',
            id: '85154834',
        },
    },
    addPetFormBlock2: {
        rbmail: {
            type: 'click',
            id: '85154835',
        },
    },
    addPetFormBlock3: {
        rbmail: {
            type: 'click',
            id: '85154836',
        },
    },
};
